import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("reset ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.data)
      ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, [
                      _renderSlot(_ctx.$slots, "default")
                    ])
                  ]),
                  _: 3
                }),
                (_ctx.editable && _ctx.getRole() == 'App.Admin')
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 0,
                      size: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          size: "small",
                          onClick: _ctx.handleEdit
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.toggleEdit ? 'Save' : 'Edit'), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    (_ctx.data)
      ? (_openBlock(), _createBlock(_component_ion_grid, {
          key: 1,
          class: "ion-no-padding"
        }, {
          default: _withCtx(() => [
            (!_ctx.toggleEdit)
              ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderedData, (value, key) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        size: _ctx.horizontal ? '' : '11',
                        key: value.flexId
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_text, { style: {"font-size":"2rm","font-weight":"bold"} }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(key), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_text, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", null, _toDisplayString(value), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["size"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_ctx.toggleEdit)
                ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter, (value, key) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_ion_col, {
                          size: _ctx.horizontal ? '' : '11',
                          key: value.flexId
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_input, {
                                  name: key,
                                  modelValue: _ctx.filter[key].friendlyName,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filter[key].friendlyName) = $event)
                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_ion_toggle, {
                                  modelValue: _ctx.filter[key].toggle,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filter[key].toggle) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_ion_button, {
                                  slot: "end",
                                  color: "warning",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.resetFilter(key))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_1
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["size"])), [
                          [_vShow, _ctx.data.hasOwnProperty(key)]
                        ])
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}